import { Field } from "formik";
import { FormGroup } from "reactstrap";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import styles from "./FormikInputFields.module.css";
import { useState } from "react";
const FormikTextField = ({
  label,
  placeholder,
  formik,
  fieldName,
  isDisabled,
  labelFontSize,
  notRequired,
  type,
  customClassNames,
  onKeyUp,
  maxLength,
  isTextArea,
  rows,
  cols,
}) => {
  const [eyeOpen, setEyeOpen] = useState(false);
  const togglePasswordVisibility = () => {
    setEyeOpen((prev) => !prev);
  };

  const isPasswordType = type === "password";
  return (
    <FormGroup>
      {label && (
        <label
          className={`fmlabel mt-6 semi-bold font-rajdhani ${
            labelFontSize && "fs-18"
          }`}
        >
          {label} {!notRequired && <span className="redstar">*</span>}
        </label>
      )}
      <div className="position-relative">
        <Field
          className={`${
            customClassNames
              ? customClassNames
              : "formik-input-field instn fs-16 regular w-100 olnone share-popup-input fmlabel black"
          }${styles.padding10} ${
            formik.errors[fieldName] &&
            formik.touched[fieldName] &&
            styles.error
          } ${isDisabled && styles.disabled}`}
          placeholder={placeholder}
          type={isPasswordType && !eyeOpen ? "password" : "text"}
          name={fieldName}
          id={fieldName}
          disabled={isDisabled}
          {...(onKeyUp && {
            onKeyUp: onKeyUp,
          })}
          {...(maxLength && {
            maxLength: maxLength,
          })}
          as={isTextArea ? "textarea" : "input"}
          {...(isTextArea && { rows, cols })}
        />
        {isPasswordType && (
          <div
            className={`${styles.eyeIcon} ${
              formik.errors[fieldName] ? styles.eyeIconOnError : ""
            }`}
            onClick={togglePasswordVisibility}
          >
            {eyeOpen ? <FaRegEye /> : <FaRegEyeSlash />}
          </div>
        )}
      </div>
      <div
        className={`error-message ${
          formik.errors[fieldName] && formik.touched[fieldName] ? "active" : ""
        }`}
      >
        {formik.touched[fieldName] && formik.errors[fieldName]}
      </div>
    </FormGroup>
  );
};

export default FormikTextField;
